export default __webpack_public_path__ + "static/media/a-1.ba949ae8.jpg";